import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login/login.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {TopbarComponent} from './topbar/topbar.component';
import {RouterModule} from '@angular/router';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatRippleModule} from '@angular/material/core';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTreeModule} from '@angular/material/tree';
import {MatBadgeModule} from '@angular/material/badge';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatRadioModule} from '@angular/material/radio';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import {SidenavService} from "../core/sidenav/sidenav.service";
import {HttpClientModule} from "@angular/common/http";
import {PageHeaderComponent} from './page-header/page-header.component';
import {DashboardCardGridComponent} from './card-grids/simple-card-grid/dashboard-card-grid.component';
import {GraphComponent} from './graph/graph.component';
import {ChartModule} from 'primeng/chart';
import { NegosSearchFormComponent } from './filter/negos-search-form/negos-search-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InformationModalComponent } from './modals/information-modal/information-modal.component';
import {BlockUIModule} from "primeng/blockui";
import {ActionButtonsComponent} from "./action-buttons/action-buttons.component";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {GoogleSigninButtonModule} from "@abacritt/angularx-social-login";

const ANGULAR_MATERIAL_MODULES = [
  MatNativeDateModule,
  MatAutocompleteModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDividerModule,
  MatExpansionModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatProgressSpinnerModule,
  MatPaginatorModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatFormFieldModule,
  MatButtonToggleModule,
  MatTreeModule,
  MatBadgeModule,
  MatGridListModule,
  MatRadioModule,
  MatDatepickerModule,
  MatTooltipModule,
  MatStepperModule,
  MatDialogModule,
  MatProgressBarModule,
  MatSlideToggleModule
];

@NgModule({
  declarations: [
    LoginComponent,
    TopbarComponent,
    SidebarComponent,
    PageHeaderComponent,
    DashboardCardGridComponent,
    GraphComponent,
    NegosSearchFormComponent,
    InformationModalComponent,
    ActionButtonsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    ChartModule,
    FormsModule,
    ReactiveFormsModule,
    BlockUIModule,
    ConfirmDialogModule,
    GoogleSigninButtonModule,
    [...ANGULAR_MATERIAL_MODULES]
  ],
  exports: [
    LoginComponent,
    TopbarComponent,
    ActionButtonsComponent,
    SidebarComponent,
    PageHeaderComponent,
    [...ANGULAR_MATERIAL_MODULES],
    DashboardCardGridComponent,
    GraphComponent,
    NegosSearchFormComponent,
    FormsModule,
    ReactiveFormsModule,
    [...ANGULAR_MATERIAL_MODULES]
  ],
  providers: [
    SidenavService,
  ],
})
export class SharedModule { }
